import { Anchor, Button } from "@sellar-io/components";
import { H2 } from "@sellar-io/components";
import { DiscoveryProductsRecentlyAddedResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import { useNavigate } from "react-router";
import { twMerge } from "tailwind-merge";
import { Icon, SpinnerLegacy } from "../../components";
import { BestPricePromiseDialog } from "../../components/bestPricePromise/BestPricePromiseDialog";
import { NavigationBar } from "../../components/navigation/NavigationBar";
import { DISCOVER, ORDER_BUYER } from "../../constants/routes";
import { useEvents, useSellarUser } from "../../hooks";
import { useDiscoverySuppliersByIdsList } from "../../hooks/api/v2/discovery/useDiscoverySupplierByIdsList";
import { useProductCuratedList } from "../../hooks/api/v2/product/useProductCuratedList";
import { useNavigateToChild } from "../../hooks/useParentNavigation";
import { getSellarWebsiteUtms } from "../../utils/utmHelper";
import { DiscoveryProductDialog } from "../discovery/v2/components/DiscoveryProductDialog";
import { DiscoveryListProductCard } from "../discovery/v2/DiscoveryListProductCard";
import { DiscoveryListSupplierCard } from "../discovery/v2/DiscoveryListSupplierCard";
import {
  setRecentlyViewedExpiry,
  useDiscoveryV2RecentlyViewedStore,
} from "../discovery/v2/DiscoveryV2RecentlyViewedStore";

export const LondonCraftBeerFestival = () => {
  const navigate = useNavigate();
  const navigateToChild = useNavigateToChild();

  const discoverySupplierListQuery = useDiscoverySuppliersByIdsList({
    query: [
      {
        type: "id",
        modifier: "IN",
        value: [
          220, 119, 110, 246, 334, 419, 386, 443, 190, 424, 193, 328, 89, 234,
          312, 331, 280, 29, 118, 6, 184, 354, 214, 288, 323, 252, 221, 20, 401,
          222, 402, 371, 236, 253, 330, 366, 422, 342, 79, 14, 439,
        ],
      },
    ],
    orderBy: "random",
  });

  const sellarFridgeProductQuery = useProductCuratedList({
    query: [
      {
        type: "id",
        modifier: "IN",
        value: [
          32344, 29671, 45591, 28079, 47830, 6074, 57674, 12627, 40344, 52379,
          2375, 2379, 13120, 60167, 60173, 4565, 55990, 4606, 14124, 40594,
          59456, 53322, 58027, 55598, 43030, 43032, 43037, 58293, 54479, 54471,
          23702, 21866, 57573, 58778, 55285, 51117, 51118, 51119, 25855, 60371,
          53665, 61026, 61016, 59507, 60561, 60656, 60587, 61072, 42580, 58927,
          59592, 62308, 62303,
        ],
      },
    ],
    orderBy: "random",
  });

  const popularProductQuery = useProductCuratedList({
    query: [
      {
        type: "supplierId",
        modifier: "IN",
        value: [
          220, 119, 110, 246, 334, 419, 386, 443, 190, 424, 193, 328, 89, 234,
          312, 331, 280, 29, 118, 6, 184, 354, 214, 288, 323, 252, 221, 20, 401,
          222, 402, 371, 236, 253, 330, 366, 422, 342, 79, 14, 439,
        ],
      },
    ],
    orderBy: "random",
  });

  const whatsOnProductQuery = useProductCuratedList({
    query: [
      {
        type: "id",
        modifier: "IN",
        value: [
          52196, 54107, 60865, 60884, 60891, 60958, 60938, 60900, 60965, 60954,
          62598, 62592, 61171, 16766, 5608, 12780, 27504, 55562, 61151, 57258,
          61444, 61433, 61437, 47458, 59583, 31083, 35135, 15480, 58782, 37214,
          33426, 33421, 61754, 56942, 59705, 59695, 17560, 51124, 56058, 47611,
          60619, 17360, 34482, 56057, 50426, 34072, 32400, 31486, 61663, 32899,
          24579, 24583, 57059, 61323, 58290, 27813, 58658, 62430, 61973, 5486,
          56569, 62349, 5504, 52864, 52304, 52332, 52326, 52325, 328, 19863,
          43748, 365, 57846, 2343, 60417, 60136, 57105, 60149, 57020, 58709,
          57112, 58688, 58723, 58694, 58833, 58720, 58607, 57964, 45989, 53923,
          24284, 3734, 5224, 7675, 3738, 22684, 22693, 32963, 57703, 22696,
          61177, 55500, 55940, 56819, 37445, 43906, 59600, 58171, 43880, 45685,
          41483, 56664, 56626, 58216, 53060, 62794, 24732, 61499, 62145, 51214,
          54650, 58046, 62367, 42437, 51097, 43243, 22024, 60745, 58677, 56033,
        ],
      },
    ],
    limit: 15,
    orderBy: "random",
  });

  const suppliers =
    discoverySupplierListQuery.data?.pages.flatMap((page) => page) ?? [];

  const sellarFridgeProducts =
    sellarFridgeProductQuery.data?.pages.flatMap((page) => page).slice(0, 20) ??
    [];

  const popularProducts =
    popularProductQuery.data?.pages.flatMap((page) => page) ?? [];

  const whatsOnProducts =
    whatsOnProductQuery.data?.pages.flatMap((page) => page) ?? [];

  const isLoading =
    discoverySupplierListQuery.isLoading ||
    sellarFridgeProductQuery.isLoading ||
    popularProductQuery.isLoading ||
    whatsOnProductQuery.isLoading;

  return (
    <div className="@container">
      <NavigationBar
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => {
          navigate(DISCOVER);
        }}
        title={"London Craft Beer Festival 2024"}
      />
      <div className="w-full border-b border-zinc-300 bg-white p-4 py-6">
        <div className="m-auto flex w-full max-w-[1200px] flex-col gap-4 @3xl:flex-row">
          <img
            src="https://sellar.imgix.net/sellar-image-assets/LCBF-2024/best-beer-festival-image.png"
            alt="London Craft Beer Festival 2024"
            className="flex-none self-center rounded-lg @3xl:order-2 @3xl:w-3/5 @4xl:w-1/2"
          />
          <div className="flex w-full flex-col gap-4 @3xl:w-2/5 @4xl:w-1/2">
            <img
              src="https://sellar.imgix.net/sellar-image-assets/LCBF-2024/lcbf-logo.png"
              alt="London Craft Beer Festival 2024"
              className="-ml-4 w-52 flex-none @3xl:ml-0"
            />
            <p>
              We are proud to be powering the trade session at London Craft Beer
              Festival 2024. Check out the suppliers set to attend the event
              below. See what's pouring, and be sure to get your free trade
              tickets to the event on us, available for all Sellar users. We'll
              be greeting you all at the entrance with friendly faces and a
              selection of beers for you to try so be sure to come and say hi!
              For more event details you can visit LCBF's website.
              <Anchor
                href="https://londoncraftbeerfestival.co.uk/"
                target="_blank"
                className="ml-1 inline-flex items-center gap-1 leading-4 font-semibold uppercase no-underline"
              >
                <Icon icon="OPEN_IN_NEW" size={0.6} />
                Visit website
              </Anchor>
            </p>
          </div>
        </div>
      </div>

      <div className="p-4">
        <div className="m-auto grid w-full max-w-[1200px] grid-cols-1 gap-4 @3xl:grid-cols-3">
          {isLoading ? (
            <SpinnerLegacy />
          ) : (
            suppliers.map((supplier) => (
              <DiscoveryListSupplierCard
                key={supplier.id}
                supplier={supplier}
                onClick={() =>
                  navigateToChild(
                    ORDER_BUYER.href({ supplierIdOrUrlId: supplier.urlId }),
                  )
                }
              />
            ))
          )}

          {!isLoading && (
            <>
              <LcbfCta className="col-span-1 col-start-1 row-start-5 @3xl:col-span-2 @3xl:col-start-2 @3xl:row-start-2" />

              <div className="col-span-1 row-start-6 overflow-hidden rounded-lg @3xl:col-span-3 @3xl:row-start-3">
                <video
                  src="https://storage.googleapis.com/sellar-partner-images/sellar-image-assets/LCBF-2024/lcbf-video.mp4"
                  autoPlay
                  playsInline
                  muted
                  controls={false}
                  loop
                  poster="https://sellar.imgix.net/sellar-image-assets/LCBF-2024/lcbf-video-poster.png"
                ></video>
              </div>

              {!!sellarFridgeProducts.length && (
                <LCBFProductList
                  title="The Sellar Beer Fridge"
                  products={sellarFridgeProducts}
                  className="col-span-1 row-start-12 @3xl:col-span-3 @3xl:row-start-6"
                />
              )}

              <LCBFProductList
                title="Popular on tap"
                products={popularProducts}
                className="@-3xl:row-start-10 col-span-1 row-start-24 @3xl:col-span-3"
              />

              <LcbfCta className="@-3xl:row-start-12 col-span-1 col-start-1 row-start-28 @3xl:col-span-2 @3xl:col-start-1" />

              <LCBFProductList
                title="What's on tap?"
                products={whatsOnProducts}
                className="@-3xl:row-start-15 col-span-1 row-start-32 @3xl:col-span-3"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const LcbfCta = ({ className }: { className?: string }) => {
  const { user } = useSellarUser();

  return (
    <div
      className={twMerge(
        "flex flex-col justify-center gap-6 rounded-lg border border-zinc-300 bg-zinc-50 p-8",
        className,
      )}
    >
      <div className="bg-opacity-30 flex h-12 w-12 items-center justify-center rounded-full border border-[#b557f1] bg-[#b557f1] text-[#b557f1]">
        <Icon icon="TICKET" />
      </div>
      <div className="flex flex-col gap-1">
        <span className="font-semibold">Get your free trade tickets</span>
        <p>
          Sellar users can apply for free tickets to the London Craft Beer
          Festival trade session on Friday 9th August
        </p>
      </div>
      <Button
        onClick={() =>
          window.open(
            user
              ? "https://share.hsforms.com/1MVm8sP1kTlSGVwtEUB07Ig3t6en"
              : "https://wearebeer.com/trade/london/",
            "_blank",
            "noreferrer",
          )
        }
      >
        Get Tickets
      </Button>
    </div>
  );
};

const LCBFProductList = ({
  title,
  products,
  className,
}: {
  title: string;
  products: DiscoveryProductsRecentlyAddedResponseType;
  className?: string;
}) => {
  const { track } = useEvents();
  const [selectedProduct, setSelectedProduct] = useState<
    DiscoveryProductsRecentlyAddedResponseType[number] | undefined
  >(undefined);
  const [bestPricePromiseDialogActive, setBestPricePromiseDialogActive] =
    useState<boolean>(false);

  const onProductClicked = (
    product: DiscoveryProductsRecentlyAddedResponseType[number],
  ) => {
    if (product.Supplier) {
      setSelectedProduct(product);
      useDiscoveryV2RecentlyViewedStore.getState().add({
        id: product.id,
        supplierId: product.Supplier.id,
        name: product.name ?? "",
        imageUrl: product.imageUrl,
        logoUrl: product.Supplier.Business?.logoUrl,
        urlId: product.Supplier.urlId,
        details: `${product.kind} // ${product.abv ?? ""}%`,
        expiry: setRecentlyViewedExpiry(),
        containsPreOrderProductItem: product.containsPreOrderProductItem,
      });

      track("Discover product clicked", {
        supplier: product.Supplier.urlId,
        product: product.name,
        source: "Recently added",
        containsPreOrderProductItem: product.containsPreOrderProductItem,
        ...getSellarWebsiteUtms(),
      });
    }
  };

  return (
    <>
      <div className={twMerge("flex flex-col gap-4 py-6", className)}>
        <H2>{title}</H2>
        <div className="flex w-full gap-4 overflow-x-scroll pb-4">
          {products.map((product) => (
            <DiscoveryListProductCard
              key={product.id}
              product={product}
              className="min-w-[300px]"
              onClick={() => onProductClicked(product)}
            />
          ))}
        </div>
      </div>

      {selectedProduct && (
        <>
          <DiscoveryProductDialog
            productId={selectedProduct.id}
            supplierId={selectedProduct.Supplier?.id}
            active={!!selectedProduct}
            onDismiss={() => {
              setSelectedProduct(undefined);
            }}
            setBestPricePromiseDialogActive={() => {
              setBestPricePromiseDialogActive(true);
            }}
          />

          <BestPricePromiseDialog
            productName={selectedProduct.name}
            buyerName={selectedProduct.name}
            supplierName={selectedProduct.Supplier?.Business?.name}
            active={bestPricePromiseDialogActive}
            onDismiss={() => setBestPricePromiseDialogActive(false)}
          />
        </>
      )}
    </>
  );
};
